import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Keeps a single <link rel="canonical"> in sync with the current path, always
 * WITHOUT the query string.
 *
 * app.teamsunday.com is entered from the marketing site with per-campaign
 * tracking params (?lang=&source=&utm_source=&utm_medium=&utm_campaign=), and
 * every combination was being indexed as a separate URL. That produced the
 * "duplicate pages without canonical" (3,711) and "3+ URL parameters" (3,703)
 * findings in the Ahrefs audit. Pointing the canonical at the clean, param-free
 * path collapses all those variants so each page is indexed exactly once.
 *
 * Query strings here are only tracking/UI state, never distinct content, so it
 * is safe to strip them for every route.
 */
export function useCanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const href = `${window.location.origin}${pathname}`;

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }, [pathname]);
}

export default useCanonicalUrl;
